import { render, staticRenderFns } from "./ArtLayout.vue?vue&type=template&id=7963ce34&"
import script from "./ArtLayout.vue?vue&type=script&lang=js&"
export * from "./ArtLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports